var screenCount = 0;
function scrollOneScreen(direction){
    var total = (document.height !== undefined) ? document.height : document.body.offsetHeight;
    var sbHeight = window.innerHeight * (window.innerHeight / document.body.offsetHeight);
    // var total = document.body.scrollHeight;
    var pos = 0;

    var inRange;
    if(screenCount == 0 && direction == -1){
        inRange = false;
    }
    else if((total / screen.height) <= screenCount+1 && direction == +1){
        inRange = false;
    }
    else{
        inRange = true;
    }

    if(inRange){
        screenCount = screenCount + direction;
    }
    pos = screen.height * screenCount;
    window.scrollTo(0, pos);

}

function scrollNextScreen(direction){
    var screens = document.getElementsByClassName('backgroundCoverFull');
    for (i = 0; i < screens.length; i++) {
        if (isInViewport(screens[i])) {
            screens[i+direction].scrollIntoView();
            break;
        }
    }
}

function scrollElementIntoView (element, behavior) {

    let scrollTop = window.pageYOffset || element.scrollTop
  
    // Furthermore, if you have for example a header outside the iframe 
    // you need to factor in its dimensions when calculating the position to scroll to
    const headerOutsideIframe = window.parent.document.getElementsByClassName('backgroundCoverFull')[0].clientHeight
  
    const finalOffset = (element.getBoundingClientRect().top + scrollTop) + headerOutsideIframe;

    window.parent.scrollTo({
      top: finalOffset,
      behavior: behavior || 'auto'
    })
  }

var isInViewport = function (elem) {
    var distance = elem.getBoundingClientRect();
	return (
		distance.top*1.99 >= 0 &&
		distance.left >= 0 &&
		distance.bottom/1.99 <= (window.innerHeight || document.documentElement.clientHeight) &&
		distance.right <= (window.innerWidth || document.documentElement.clientWidth)
	);
};

// NOT SURE WHAT THIS WAS USED FOR? MAYBE 1PAGE SCROLLING?
// window.onscroll = function() {
//     var top = document.body.scrollTop + document.documentElement.scrollTop == 0;
//     var scrollup = document.getElementById('scrollUp');
//     var scrolldown = document.getElementById('scrollDown');

//     if(scrollup == null || scrolldown == null){
//         return;
//     }

//     if(top){
//         scrollup.style.display = 'none';
//         scrolldown.style.width = '100%';
//     }
//     else{
//         scrollup.style.display = 'block';
//         scrolldown.style.width = '50%';
//     }

//     // you're at the bottom of the page
//     if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
//         scrolldown.style.display = 'none';
//         scrollup.style.display = 'none';
//         // scrollup.style.width = '100%';
//     }
//     else{
//         scrolldown.style.display = 'block';
//         // scrollup.style.display = 'block';
//         // scrollup.style.width = '50%';
//     }

// };